var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-info-component',{attrs:{"title":_vm.$t('pages.permission.confirm_waiting'),"value":_vm.value,"is-loading":_vm.isLoading,"icon":"fa-hourglass-half","tone":"warning"}})}
var staticRenderFns = []

export { render, staticRenderFns }